module.exports = __webpack_public_path__ + "img/q7.cd68a289.png";